export class Setting{
    public id: number;
    public key: string;
    public value: string;
}